import type { LogoutRepository } from '@/domains/auth/logout.repository';
import { useAuthStore } from '@/shared/stores';
import { logoutApiService } from '../http/logout.api';

/**
 * Implementación completa del repositorio de logout
 * Maneja invalidación en servidor + limpieza local
 */
class LogoutApiRepository implements LogoutRepository {
  async logout(): Promise<void> {
    try {
      // 1. Invalidar token en servidor (no bloquea si falla)
      await logoutApiService.logout();
    } catch (error) {
      // Log pero continúa con logout local
      console.warn(
        'Fallo al invalidar token en servidor, continuando con logout local:',
        error,
      );
    }

    // 2. Limpiar store local (siempre debe ejecutarse)
    useAuthStore.getState().logout();
  }
}

export const logoutApiRepository = new LogoutApiRepository();
